import { Theme } from '@emotion/react';

export const generateHeaderStyles = (theme: Theme) => ({
    header: {
        textAlign: 'center',
        paddingTop: '102px',
        paddingBottom: '143px',
        backgroundColor: theme.palette.primary.primaryDark,
        color: theme.palette.common.white,
        fontWeight: 'normal',
        maxHeight: '340px',
        fontFamily: theme.palette.common.font,
        position: 'static',
        letterSpacing: '0.25px',
    },
    title: {
        fontSize: '32px',
        fontWeight: 400,
        marginTop: '15px',
        marginBottom: '24px',
    },
    subTitle: {
        fontSize: '18px',
        fontWeight: 500,
    },
    headerFixed: {
        transition: '2s',
        zIndex: 1000,
        position: 'fixed',
        top: 0,
        width: 'calc(100% - 16px)',
        left: '50%',
        transform: 'translateX(-50%)',
        paddingTop: '24px',
        paddingBottom: '24px',
        '&::before': {
            content: "''",
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '8px',
            backgroundColor: theme.palette.common.white,
            zIndex: 999,
        },
        '& .breadcrumbs': {
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            marginBottom: '10px',
            color: theme.palette.common.black,
        },

    },
    subTitleFixed: {
        marginBottom: '16px',
    },
    breadcrumbsWrapper: {
        position: 'absolute',
        top: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        textAlign: 'left',
        backgroundColor: theme.palette.common.white,
    },
    breadcrumbsLink: {
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
    },
    breadcrumbs: {
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        marginBottom: '10px',
        color: theme.palette.common.black,
    },
});
